import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import StorageService, { StorageKeys } from '../../services/StorageService'

interface State {
	isAuth: boolean
	commonModal: {
		isShow: boolean
		message: string
	}
	commonSnackbar: {
		isShow: boolean
		message: string
	}
}

const initialState: State = {
	isAuth: !!StorageService.getItem(StorageKeys.access_token),
	commonModal: {
		isShow: false,
		message: '',
	},
	commonSnackbar: {
		isShow: false,
		message: '',
	},
}

export const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		openModal: (state, action: PayloadAction<string>) => {
			state.commonModal = { isShow: true, message: action.payload }
		},
		openSnackbar: (state, action: PayloadAction<string>) => {
			state.commonSnackbar = { isShow: true, message: action.payload }
		},
		closeSnackbar: (state) => {
			state.commonSnackbar = { isShow: false, message: '' }
		},
		closeModal: (state) => {
			state.commonModal = { isShow: false, message: '' }
		},
		logout: (state) => {
			StorageService.clearStorage()
			state.isAuth = false
		},
		setIsAuth: (state) => {
			state.isAuth = true
		},
	},
})

export const {
	openModal,
	closeModal,
	logout,
	setIsAuth,
	openSnackbar,
	closeSnackbar,
} = appSlice.actions

export const selectCommonModal = (state: RootState) => state.app.commonModal

export default appSlice.reducer
